const documentFiles = [
  {
    name: "Share Transfer Agreement",
    link: "/documents/share-transfer-agreement.hwp",
  },
  {
    name: "삼정KPMG 미국 IPO 시장 동향과 국내 기업의 미국시장 상장",
    link: "/documents/삼정KPMG-미국-IPO-시장-동향과-국내-기업의-미국시장-상장-20250415.pdf",
  },
  {
    name: "CCI Listing Intro (Eng)",
    link: "/documents/CCI_Listing_Intro_ENG.pdf",
  },
];

export default documentFiles;
